import { useGetPromoEventData } from './useGetPromoEventData';

export const usePromoEvent = () => {
	const { data, isSuccess, isResolved } = useGetPromoEventData();

	const active = isResolved ? !!data : false;

	return {
		active,
		isResolved,
		logoUrl: isSuccess && data?.logoUrl,
		headerSubscriptionText: isSuccess
			? data?.headerSubscriptionText
			: undefined,
		gridImageUrl: isResolved && data?.gridImageUrl,
	};
};
